export default "__VITE_ASSET__BZrZgRwD__"